import type { PaymentProviderBase } from "../payment-provider-base";
import type {
    OnPremisePaymentType} from "./on-premise-payment-type";
import {
    onPremisePaymentTypes,
} from "./on-premise-payment-type";

const onPremisePaymentProvider: PaymentProviderBase<
    "ONPREMISE",
    OnPremisePaymentType
> = {
    _type: "ONPREMISE-PAYMENT_PROVIDER",
    name: "ONPREMISE",
    displayName: "På plats",
    paymentTypes: onPremisePaymentTypes,
};

type OnPremisePaymentProvider = typeof onPremisePaymentProvider;

export type { OnPremisePaymentProvider };
export { onPremisePaymentProvider };
